jQuery(document).ready(function() {
    var base_url = "https://api-fai.analyticom.de";
    var competitionId = 30664819;
    var teamIdFilter = 10614;
    var api_mens_senior_tbl = base_url + "/api/live/competition/" + competitionId + "/standings/official?teamIdFilter=" + teamIdFilter;
    var api_key = "8f03d750e912f7ff66d3b5eb1ca39f66d762785059470f85723d7513a71ae097106e5b8d3a548b85e60d49ec9fec2471e2086e9cc95f2f22f741f1962d3db004";
    jQuery.ajax({
        url: api_mens_senior_tbl,
        type: "get",
        headers: {
        "API_KEY": api_key,
        },
        dataType: "json",
        success: function(response) {
        //console.log(response);
        var content = "";
        let position = 0;
        var url_faiconnect = "https://faiconnect.ie/file?id=";
        content += "<thead><tr><th></th>";
        content += "<th>Team</th><th>P</th><th>W</th><th>D</th>";
        content += "<th>L</th><th>GD</th><th>Pts</th>";
        content += "</tr></thead>";
        content += "<tbody>";
        jQuery.each(response, function (key, value) {
            //console.log(value);
            position = position + 1;
            var goalDiff = value?.goalsFor - value?.goalsAgainst;
            var team_img_url = url_faiconnect+value.team.picture;
            content += "<tr id= '"+ value?.team.parent.place +"'>";
            content += "<td>" +  position + "</td>";
            content += "<td>" + "<img id='team-crest' src='"+ team_img_url +"' alt='"+ value?.team.name +"' loading='lazy'/>" + "<span>" +  value?.team.name + "</span>" + "</td>";
            content += "<td>" + value?.played + "</td>";
            content += "<td>" + value?.wins + "</td>";
            content += "<td>" + value?.draws + "</td>";
            content += "<td>" + value?.losses + "</td>";
            content += "<td>" + goalDiff + "</td>";
            content += "<td>" + value?.points + "</td>";
            content += "</tr>";
        });
        content += "</tbody>";
        //insert rows into table.
        jQuery('#league-card-tbl').html(content);
        },
        error: function(errorThrown){
        console.log(errorThrown);
        },
    });    
});